import ButterToast, { Cinnamon, POS_RIGHT, POS_TOP } from 'butter-toast'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { client } from '../utils'

const App = ({ coursenum }) => {
  const [statusData, setStatusData] = useState([])
  const [file, setFile] = useState();
  const [uploadedFile, setUploadedFile] = useState();
  const [error, setError] = useState();
  const [contentType, setContentType] = useState();
  const [loadingStatus, setLoadingStatus] = useState(true);

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const response = await client.get(`/instructor/admin_setup.get_chatbot_status/${coursenum}/`)
        setStatusData(response.data.statuses)

      } catch (err) {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error while fetching the chatbot status. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
      }
      finally {
        setLoadingStatus(false)
      }
    }

    fetchStatusData()
  }, [coursenum])

  const handleSendChatbotData = async () => {
    const maxRetries = 3
    let retryCount = 0

    const sendData = async () => {
      try {
        await client.post(`/instructor/admin_setup.send_textbook_data_to_chatbot/${coursenum}/`)
        window.location.reload()
      } catch (err) {
        if (retryCount < maxRetries) {
          retryCount++
          await new Promise(resolve => setTimeout(resolve, 1000 * retryCount)) // Exponential backoff
          return sendData()
        }
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error while sending the chatbot data. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
        throw err // Re-throw to be caught by error boundary if present
      }
    }

    await sendData()
  }

  const handleMissingPagesCheck = async () => {
    try {
      const response = await client.post(`/instructor/admin_setup.check_missing_pages/${coursenum}/`)
      const data = response.data

      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Missing Pages Check"
            content={`Total pages: ${data.total_pages}
Missing pages: ${data.missing_pages}
Sample missing IDs: ${data.missing_page_ids.join(', ')}`}
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-info-circle fa-3x" />}
          />
        ),
      })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`Error checking missing pages: ${err}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
  }

  const handleChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = (selectedFile.name.split('.').pop().toLowerCase());
    if (fileExtension !== 'pdf' && fileExtension !== 'txt') {
      console.error('Invalid file type. Only PDF and TXT files are accepted.');
      setFile(null);
      return;
    }
    setFile(selectedFile);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const url = `/instructor/admin_setup.upload_chatbot_context_file/${coursenum}/`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    formData.append('coursenum', coursenum);
    formData.append('fileType', contentType);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    await client.post(url, formData, config)
      .then((response) => {
        setUploadedFile(response.data.file);
      })
      .catch((error) => {
        console.error("Error uploading file: ", error);
        setError(error);
      });
  }

const handleDelete = async (id, type) => {

  const url = `/instructor/admin_setup.delete_chatbot_context_file/${coursenum}/`;
  const payload = { document_id: id, file_type: type };

  try {
    await client.post(url, payload);
    ButterToast.raise({
      content: (
        <Cinnamon.Crunch
          title="Success"
          content="File deleted successfully."
          scheme={Cinnamon.Crisp.SCHEME_GREEN}
          icon={<i className="far fa-check-circle fa-3x" />}
        />
      ),
    });
    const updatedStatusData = statusData.filter(item => item.type !== type);
    setStatusData(updatedStatusData);
  } catch (error) {
    console.error("Error deleting file: ", error);
    setError(error);
    ButterToast.raise({
      content: (
        <Cinnamon.Crunch
          title="Error"
          content={`There was an error while deleting the file. ${error}`}
          scheme={Cinnamon.Crisp.SCHEME_RED}
          icon={<i className="far fa-exclamation-triangle fa-3x" />}
        />
      ),
    });
  }
}

  const handleFileTypeChange = (event) => {
    setContentType(event.target.value);
  }

  return (
    <React.Fragment>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <h3>Chatbot Services</h3>
      <Button
        className="btn btn-default btn-myed btn-default-myed btn-sm-myed"
        onClick={handleSendChatbotData}
        style={{ marginBottom: '20px', marginRight: '10px' }}
      >
        Send Chatbot Data
      </Button>
      <Button
        className="btn btn-default btn-myed btn-default-myed btn-sm-myed"
        onClick={handleMissingPagesCheck}
        style={{ marginBottom: '20px' }}
      >
        Missing Pages Check
      </Button>


      <div className="chatbot-file-upload">
        <h3>Chatbot File Upload</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fileType">Select file type:</label>
            <select
              id="fileType"
              name="fileType"
              className="form-control"
              value={contentType}
              onChange={handleFileTypeChange}
            >
              <option value="materials">Materials</option>
              <option value="syllabus">Syllabus</option>
              <option value="assignments">Assignments</option>
              <option value="exams">Exams</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="file">Choose a file:</label>
            <input
              type="file"
              id="file"
              accept=".pdf,.txt"
              className="form-control-file"
              onChange={handleChange}
            />
          </div>

          <Button type="submit" variant="primary">
            Upload
          </Button>
        </form>

        {uploadedFile && (
          <div className="mt-3">
            <p className='label label-success'>File uploaded successfully</p>
          </div>
        )}
        {error && (
          <p className="text-danger mt-3">
            Error uploading file: {error.message}
          </p>
        )}
      </div>
      {loadingStatus ? (
        <div style={{textAlign: "center", margin: "20px"}}>Loading Chatbot context status...</div>

      ): <div></div>}
      {statusData.length > 0 && (
        <div>
          <h4>Chatbot Context Status:</h4>
          {statusData.map((item, index) => (
            <div key={index} style={{ border: '1px solid gray', borderRadius: '5px', padding: '10px', marginBottom: '10px' }}>
              <p><strong>Type:</strong> {item.type}</p>
              <p>
                <strong>Status:</strong>
                <span className={`label label-${item.status === 'completed' ? 'success' : item.status === 'processing' ? 'warning' : 'danger'}`}>
                  {item.status}
                </span>
              </p>
              {item.progress && (
                <div className="progress-info">
                  <div className="progress" style={{ height: '20px', marginBottom: '5px' }}>
                    <div
                      className="progress-bar progress-bar-success"
                      style={{ width: `${(item.progress.completed / item.progress.total) * 100}%` }}
                      title={`${item.progress.completed} completed`}
                    />
                    <div
                      className="progress-bar progress-bar-warning"
                      style={{ width: `${(item.progress.processing / item.progress.total) * 100}%` }}
                      title={`${item.progress.processing} processing`}
                    />
                    <div
                      className="progress-bar progress-bar-danger"
                      style={{ width: `${(item.progress.error / item.progress.total) * 100}%` }}
                      title={`${item.progress.error} error`}
                    />
                  </div>
                  <div className="progress-legend" style={{ fontSize: '0.9em', color: '#666' }}>
                    <span style={{ marginRight: '15px' }}>
                      <i className="fa fa-square" style={{ color: '#5cb85c' }}></i> Completed: {item.progress.completed}
                    </span>
                    <span style={{ marginRight: '15px' }}>
                      <i className="fa fa-square" style={{ color: '#f0ad4e' }}></i> Processing: {item.progress.processing}
                    </span>
                    <span>
                      <i className="fa fa-square" style={{ color: '#d9534f' }}></i> Error: {item.progress.error}
                    </span>
                  </div>
                </div>
              )}
              <p><strong>Last Updated:</strong> {new Date(item.lastUpdated).toLocaleString()}</p>
              <Button variant="danger" onClick={() => handleDelete(item.id, item.type)}>Delete</Button>
            </div>
          ))}
        </div>
      )}

    </React.Fragment>
  )
}

export default App
